var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-calendar',_vm._b({attrs:{"events":_vm.events}},'v-calendar',_vm.result,false))}
var staticRenderFns = []

export { render, staticRenderFns }